export default function NewSyncableSectionTitleChangeController(
) {
   const vm = this;

  _activate();

  function _activate() {
    var z = 1;
    vm.change.breadcrumb = breadcrumb();
  }

  function breadcrumb() {
    return vm.change.breadcrumbs.join(' -> ');
  }
}

NewSyncableSectionTitleChangeController.$inject = [
];
